import {entries} from '../collection'
import {take} from 'remeda'
import {RecursiveKeyValuePair} from 'tailwindcss/types/config'
import {P, match} from 'ts-pattern'
import {T} from 'ts-toolbelt'

export const fromTwColor = (pallet: RecursiveKeyValuePair) =>
  take(
    entries(pallet)
      .filter(([number, _], i) =>
        match(number)
          .with(P.string.regex(/\d+/), s => true)
          .otherwise(() => false)
      )
      .map(([_, color]) => color),
    10
  ) as T.Repeat<string, 10>
